import * as React from 'react';

import {FieldArray} from 'redux-form';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {AudienceSelect} from './audience-select';

type Props = {
    shouldAnd?: boolean;
};

export function AudienceForm(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <Body>Which audience?</Body>
            <FieldArray name='audiences' component={AudienceSelect} shouldAnd={props.shouldAnd} />
        </StackLegacy>
    );
}
